/**
 * Strips the suffix GitHub write-back adds to issue titles (`buildIssueTitle` in github.service.ts).
 * Webhook sync used to persist the full GitHub title into `tasks.title`; this keeps display/search clean.
 */
export function stripSentralTaskSuffixFromTitle(title: string | undefined | null): string {
  if (title == null || title === '') return '';
  return title.replace(/\s*\[Task:[^\]]+\]\s*$/i, '').trim();
}

/** Prefer stripped title; if stripping removes everything, fall back to the raw string. */
export function displayTaskTitle(raw: unknown): string {
  if (typeof raw !== 'string') return '';
  const stripped = stripSentralTaskSuffixFromTitle(raw);
  return stripped.length > 0 ? stripped : raw.trim();
}
